import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';

@Injectable()
export class ClientGuard implements CanActivate {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private roleService: NgxRolesService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if ((this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT'))
      && this.authService.getUser().id !== this.route.params['clientId']
    ) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/client.guards.ts